import { combineReducers } from 'redux'
import routes from '../routes'
import { persistReducer, createMigrate } from 'redux-persist'
import webStorage from 'localforage'
import capacitorStorage from '../../lib/CapacitorPersistStorage'

import channelsReducer from './channels'
import channelLayoutReducer from './channelLayout'
import channelSettingsReducer from './channelSettings'
import cellsReducer from './cells'
import systemReducer from './system'
import marketMoversReducer from './marketMovers'
import trainingVideosReducer from './trainingVideos'
import userReducer from './user'
import pageReducer from './page'
import drawerReducer from './drawer'
import modalReducer from './modal'
import cellDecoratorsReducer from './cellDecorators'
import createNullMigrate, { persistMigrations } from '../misc'
import config from '../../config.json'
import { isNative } from '../../utils/utils';
import { USER_ACTIONS } from '../actions/user'

const storage = isNative() ? capacitorStorage : webStorage;

const channelPersistConfig = {
  key: 'channels',
  blacklist: ['activeChannel'],
  version: config.STORE_VERSION,
  storage,
  migrate: createNullMigrate()
};

// Combine all reducers.
const appReducer = combineReducers({
  channels: persistReducer(channelPersistConfig, channelsReducer),
  channelLayout: channelLayoutReducer,
  channelSettings: channelSettingsReducer,
  cells: cellsReducer,
  cellDecorators: cellDecoratorsReducer,
  system: systemReducer,
  marketMovers: marketMoversReducer,
  trainingVideos: trainingVideosReducer,
  user: userReducer,
  location: routes.reducer,
  page: pageReducer,
  drawer: drawerReducer,
  modal: modalReducer,
});

// Wrap the app reducer with, essentially, a logout reducer.
const rootReducer = (state: any, action: any) => {
  // On log out wipe the entire state except for the system state.
  if(action.type === USER_ACTIONS.LOGOUT){
    state = {
      system: {
        ...state.system
      }
    }
  }

  return appReducer(state, action)
}

// Configure redux-persist. Blacklist things, apply storage and transforms.
const persistConfig = {
  key: 'root',
  whitelist: ['channelSettings', 'system', 'user'],
  version: config.STORE_VERSION,
  storage,
  migrate: createMigrate(persistMigrations)
};

const persistedReducer = persistReducer(persistConfig, rootReducer)

export type RootState = ReturnType<typeof rootReducer>

export default persistedReducer